/**
 * @param {object[]} tree
 * @param {string} id
 * @returns {object}
 */
export default function findCategoryInTree(tree, id) {
  const thisLevelResult = tree.find(c => c.id === id || c.short_id === id);
  if (thisLevelResult !== undefined) {
    return thisLevelResult;
  }
  for (let category of tree) {
    const result = category.children && findCategoryInTree(category.children, id);
    if (result) return result;
  }
  return undefined;
}
